module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0002.00b12f8d.jpg";